<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.3" cx="11" cy="11" r="8" :fill="color" />
    <path
      d="M18.0419 18.5002L21.5 21.9581"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "24",
  },
  height: {
    type: [String, Number],
    default: "24",
  },
  color: {
    type: String,
    default: "#003D6A",
  },
  strokeWidth: {
    type: [String, Number],
    default: "1.5",
  },
});
</script>
